import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const [productsRes, categoriesRes] = await Promise.all([
        apiFetch('/api/products'),
        apiFetch('/api/categories'),
      ]);
      const productsData = await productsRes.json();
      const categoriesData = await categoriesRes.json();
      setProducts(Array.isArray(productsData) ? productsData : []);
      setCategories(Array.isArray(categoriesData) ? categoriesData : []);
    };
    fetchData();
  }, []);

  const getCategoryLabel = (categoryField) => {
    if (!categoryField) return '-';
    if (typeof categoryField === 'object') {
      return categoryField.name || '-';
    }
    const match = categories.find((cat) => cat._id === categoryField);
    return match ? match.name : categoryField;
  };

  const getCategorySection = (categoryField) => {
    if (!categoryField) return '-';
    if (typeof categoryField === 'object') {
      if (categoryField.section) return categoryField.section;
      const match = categories.find((cat) => cat._id === categoryField._id);
      return match ? match.section : '-';
    }
    const match = categories.find((cat) => cat._id === categoryField);
    return match ? match.section : '-';
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you strictly sure you want to delete this?')) {
      const res = await apiFetch(`/api/products/${id}`, {
        method: 'DELETE'
      });
      if (res.ok) {
        setProducts(products.filter(p => p._id !== id));
      }
    }
  };

  const handleToggleAvailability = async (id, newIsAvailable) => {
    try {
      const res = await apiFetch(`/api/products/${id}`, {
        method: 'PUT',
        body: JSON.stringify({ isAvailable: newIsAvailable })
      });
      if (res.ok) {
        setProducts(products.map(p => p._id === id ? { ...p, isAvailable: newIsAvailable } : p));
      } else {
        const errorData = await res.json();
        alert(errorData.message || 'Failed to update availability');
      }
    } catch (err) {
      console.error(err);
      alert('Error updating product availability');
    }
  };

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#f97316' }}>Manage Products</h2>
        <Link to="/admin/add-product" className="btn">+ Add Product</Link>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={tableStyle}>
          <thead>
            <tr style={rowStyle}>
              <th style={thStyle}>ID</th>
              <th style={thStyle}>NAME</th>
              <th style={thStyle}>PRICE</th>
              <th style={thStyle}>SECTION</th>
              <th style={thStyle}>CATEGORY</th>
              <th style={thStyle}>STATUS</th>
              <th style={thStyle}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <tr key={product._id} style={rowStyle}>
                <td style={tdStyle}>{product._id.substring(0, 8)}...</td>
                <td style={tdStyle}>{product.name}</td>
                <td style={tdStyle}>₹{product.price.toFixed(2)}</td>
                <td style={tdStyle}>{getCategorySection(product.category)}</td>
                <td style={tdStyle}>{getCategoryLabel(product.category)}</td>
                <td style={tdStyle}>
                  <select
                    value={product.isAvailable ? 'true' : 'false'}
                    onChange={(e) => handleToggleAvailability(product._id, e.target.value === 'true')}
                    style={{
                      background: 'var(--color-surface-2, #0f172a)',
                      color: product.isAvailable ? '#10b981' : '#ef4444',
                      border: '1px solid var(--color-border-light, rgba(255, 255, 255, 0.1))',
                      borderRadius: '6px',
                      padding: '6px 12px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      outline: 'none',
                    }}
                  >
                    <option value="true" style={{ background: 'var(--color-surface-1)', color: '#10b981' }}>Available</option>
                    <option value="false" style={{ background: 'var(--color-surface-1)', color: '#ef4444' }}>Unavailable</option>
                  </select>
                </td>
                <td style={tdStyle}>
                  <Link to={`/admin/edit-product/${product._id}`} style={editBtn}>Edit</Link>
                  <button onClick={() => handleDelete(product._id)} style={deleteBtn}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const containerStyle = { maxWidth: '1200px', margin: '40px auto', padding: '30px', background: 'var(--color-surface-1)', borderRadius: '12px', border: '1px solid var(--color-border-light, rgba(255,255,255,0.05))', color: 'var(--color-text-primary)' };
const tableStyle = { width: '100%', borderCollapse: 'collapse' };
const rowStyle = { borderBottom: '1px solid var(--color-border-light, rgba(255,255,255,0.1))' };
const thStyle = { padding: '15px', textAlign: 'left', color: 'var(--color-text-secondary)', fontSize: '0.9rem' };
const tdStyle = { padding: '9px', textAlign: 'left' };
const editBtn = { background: '#3b82f6', color: 'var(--color-text-primary)', padding: '6px 12px', borderRadius: '4px', marginRight: '10px' };
const deleteBtn = { background: '#ef4444', color: 'var(--color-text-primary)', padding: '6px 12px', borderRadius: '4px', border: 'none', cursor: 'pointer' };

export default AdminProducts;
